<template>
  <div>
    <div class="contentBox w">
      <div class="contentStitle">Human resource system development</div>
      <div class="contentTitle">人力资源系统开发</div>
      <div class="contentLine">
        <span class="lineLeft"></span>
        <span class="lineMiddle"></span>
        <span class="lineRight"></span>
      </div>
      <div class="yjh_item">
        <div class="yjh_item_text text_left">
          <div class="text_box">
            <div class="text_line"></div>
            <div class="text_title">人力资源系统开发简介！</div>
          </div>
          <div class="text_content">
            随着时代的发展，线上办公协作已日趋深度流行。云久鸿应时代之变，集行业之精英，积极探索人力资源行业信息化的发展之路。通过线上人力资源系统平台的建设，营造数字化业务场景与线下网点形成互补交融，使业务模式更加多元。在节省人力资源成本的同时，更为企业发展和决策提供了数据支撑。
          </div>
        </div>
        <div class="yjh_item_img">
          <img :src="src.qyfw" alt srcset />
        </div>
      </div>
    </div>
    <div class="mobile_contentBox">
      <div class="contentTitle noStitle">人力资源系统开发</div>
      <div class="contentLine">
        <span class="lineLeft"></span>
        <span class="lineMiddle"></span>
        <span class="lineRight"></span>
      </div>
      <div class="mobile_yjh_item">
        <div class="mobile_yjh_item_text">
          <div class="text_line"></div>
          <div class="text_title">人力资源系统开发简介！</div>
        </div>
        <div class="mobile_yjh_item_content">
          随着时代的发展，线上办公协作已日趋深度流行。云久鸿应时代之变，集行业之精英，积极探索人力资源行业信息化的发展之路。通过线上人力资源系统平台的建设，营造数字化业务场景与线下网点形成互补交融，使业务模式更加多元。在节省人力资源成本的同时，更为企业发展和决策提供了数据支撑。
        </div>
        <div class="mobile_yjh_item_img">
          <img :src="src.qyfw" alt srcset />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import src from "../../../utils/assets";
export default {
  data() {
    return {
      src: src,
    };
  },
}
</script>

<style lang="less" scoped></style>
